import React from 'react'
import css from './MainColumn.module.css'

interface MainColumnProps {
  children: React.ReactNode
}

const MainColumn = ({ children }: MainColumnProps) => (
  <section className={css.wrapper}>
    {children}
  </section>
)

export { MainColumn }
